import { ebGlobalChannel } from 'src/lib/events-bridge';
import EBAPIs from 'src/lib/events-bridge/topics';
const subscribers = new Map();
function publish(eventName, ...args) {
    subscribers.get(eventName)?.forEach(callback => callback(args[0]));
}
ebGlobalChannel.subscribe(EBAPIs.keyboard.event, ({ eventName, args }) => {
    publish(eventName, ...args);
});
const Keyboard = {
    isVisible() {
        return false;
    },
    addListener(eventName, callback) {
        if (!subscribers.has(eventName)) {
            subscribers.set(eventName, []);
        }
        subscribers.get(eventName).push(callback);
        return {
            remove() {
                Keyboard.removeListener(eventName, callback);
            },
        };
    },
    dismiss() {
        const el = document.activeElement;
        el?.blur?.();
    },
    removeAllListeners(eventName) {
        if (eventName)
            subscribers.delete(eventName);
        else
            subscribers.clear();
    },
    removeListener(eventName, callback) {
        const list = subscribers.get(eventName);
        if (!list)
            return;
        const i = list.indexOf(callback);
        if (i !== -1)
            list.splice(i, 1);
    },
};
export default Keyboard;
